import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const UpdateFamilyCommunicationRequestDtoSchema = z.object({
  id: z.number(),
  date: z.date(),
  title: z.string(),
});

export const UpdateFamilyCommunicationResponseDtoSchema = z.object({
  date: z.coerce.date(),
  fileUrl: z.string(),
  id: z.number(),
  residentId: z.number(),
  title: z.string(),
  uploadedBy: z.object({
    id: z.number(),
    fullName: z.string(),
  }),
});

export type UpdateFamilyCommunicationRequestDto = z.infer<
  typeof UpdateFamilyCommunicationRequestDtoSchema
>;
export type UpdateFamilyCommunicationResponseDto = z.infer<
  typeof UpdateFamilyCommunicationResponseDtoSchema
>;

export const updateFamilyCommunication = (
  params: UpdateFamilyCommunicationRequestDto,
  config?: AxiosRequestConfig<UpdateFamilyCommunicationRequestDto>
) => {
  const { id, ...data } = params;

  return api
    .patch(`family-communication/${id}`, data, config)
    .then(responseContract(UpdateFamilyCommunicationResponseDtoSchema));
};
